// Sekcja „Historia": ostatni deploy w jednej linii, rozwiniete = pelna lista.
import { useCallback, useEffect, useState } from "react";
import { CheckCircle2, XCircle, Loader2, History } from "lucide-react";
import type { StaticSiteRow } from "@/services/staticSite/types";
import { listDeploys, type DeployHistoryRow } from "@/services/staticSite/migrationRunner";
import { StudioSection } from "./StudioSection";
import { DeployHistoryList } from "./DeployHistoryList";

export function HistoryRow({ site }: { site: StaticSiteRow }) {
  const [history, setHistory] = useState<DeployHistoryRow[]>([]);
  const load = useCallback(async () => {
    try { setHistory(await listDeploys(site.id, 12)); } catch { /* ignore */ }
  }, [site.id]);
  useEffect(() => { void load(); }, [load, site.last_deploy_id, site.updated_at]);

  const last = history[0];
  const summary = last ? (
    <span className="flex flex-wrap items-center gap-2 text-xs">
      {last.status === "success" ? <CheckCircle2 className="h-3.5 w-3.5 text-emerald-500" /> : last.status === "failed" ? <XCircle className="h-3.5 w-3.5 text-red-500" /> : <Loader2 className="h-3.5 w-3.5 animate-spin" />}
      <span>{new Date(last.started_at).toLocaleString("pl-PL", { dateStyle: "short", timeStyle: "short" })}</span>
      <span className="text-muted-foreground">{last.status}{last.file_count != null ? ` · ${last.file_count} plików · wgrano ${last.uploaded_count ?? 0}` : ""}{last.branch !== "main" ? ` · ${last.branch}` : ""}</span>
      {history.length > 1 && <span className="text-muted-foreground">· {history.length} deployów</span>}
    </span>
  ) : (
    <span className="text-xs text-muted-foreground">Jeszcze nie było deployu.</span>
  );

  return (
    <StudioSection icon={History} title="Historia" collapsible defaultOpen={false} summary={summary} help="Każde „Przenieś” i każdy podgląd Astro zapisuje wiersz z liczbą plików, adresem i logiem builda.">
      <DeployHistoryList history={history} />
    </StudioSection>
  );
}
